import { trigger, state, style, transition, animate } from '@angular/animations';

export const HELP_ANIMATIONS = [
    trigger('fade', [
        state('fadeIn', style({
            display: 'block'
        })),
        state('fadeOut', style({
            display: 'none',
            height: 0,
            opacity: 0
        })),
        transition('fadeIn => fadeOut', animate('0.3s ease-in')),
        transition('fadeOut => fadeIn', animate('0.3s ease-in')),
    ]),
  ];



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/section/section.animations.ts